
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interaction-designer",
      function () {
        return require("private-next-pages/interaction-designer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interaction-designer"])
      });
    }
  